// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-toast-message ui-shadow ui-toast-message-success ng-trigger ng-trigger-messageState {
  background-color: #b7d8b7 !important;
  border: 0 none;
  color: #212121;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/home.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,cAAA;EACA,cAAA;AACF","sourcesContent":[".ui-toast-message ui-shadow ui-toast-message-success ng-trigger ng-trigger-messageState {\r\n  background-color: #b7d8b7 !important;\r\n  border: 0 none;\r\n  color: #212121;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
